<template>
  <div>
    <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false">

      <Form ref="formValidate" :model="params" :rules="ruleValidate" :label-width="100">
        <FormItem label="姓名：" prop="realName">
          <span>{{params.realName}}</span>
        </FormItem>
        <FormItem label="代理地区：" prop="region">
          <span>{{params.region}}</span>
        </FormItem>
        <FormItem label="充值金额：" prop="num">
          <InputNumber v-model="params.num" :min="1" :formatter="value => `${parseInt(value)}`" :max="20000"></InputNumber>
        </FormItem>
        <Alert type="warning" show-icon closable style="margin-top:10px">涉及金额变更请谨慎操作</Alert>
      </Form>

      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
        <Button @click="hide('formValidate')">取消</Button>
        <Button type="primary" @click="addAdmin()" :loading="loadingBtn">
          <span v-if="!loadingBtn">确定</span>
          <span v-else>请稍候...</span>
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "tenant-ope",
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      title: '加盟商余额充值',
      params: {
        tenantId: '',
        realName: '',
        num: 0
      },
      tenant: {},
      ruleValidate: {
        num: [
          {required: true, message: '充值金额不能为空', trigger: 'change', type: 'number'},
        ],
      }
    }
  },
  methods: {
    // 显示模态框
    show(row) {
      this.isShowModal = true;
      this.params = row
    },
    // 新增加盟商
    addAdmin() {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.$Spin.show();
          this.axios.post('/tenant/recharge', this.params).then(res => {
            setTimeout(() => {
              this.$Spin.hide();
            }, 300);
            if (res.status == 200) {
              this.$emit('changeDate');
              this.$Message.success('操作成功.');
              this.hide('formValidate');
            }
            if (res.status == 201) {
              this.$Message.error(res.msg);
            }
            if (res.status == 500) {
              this.$Notice.error({
                title: '服务器内部错误',
                desc: '加盟商充值接口报错',
                duration: 0
              });
            }
          })
        } else {
          this.$Message.error('还有信息没有填写合格哦~');
        }
      })
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      this.params.num = '';
      this.params.tenantId = '';
      // this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped>

</style>